<div class="relative overflow-hidden">
  <!-- Dekoracyjne tło -->
  <div class="absolute inset-0 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900"></div>
  <div class="absolute top-0 right-0 w-64 h-64 bg-blue-100/50 dark:bg-blue-900/10 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl"></div>
  <div class="absolute bottom-0 left-0 w-48 h-48 bg-indigo-100/50 dark:bg-indigo-900/10 rounded-full translate-y-1/2 -translate-x-1/2 blur-3xl"></div>
  
  <div class="relative flex flex-col items-center justify-center p-8 sm:p-10 text-center mx-auto max-w-md">
    <!-- Ikona -->
    <div class="relative mb-6">
      <div class="absolute inset-0 bg-blue-400/20 dark:bg-blue-500/20 rounded-full animate-ping"></div>
      <div class="relative p-5 bg-gradient-to-br from-blue-500 to-indigo-600 dark:from-blue-600 dark:to-indigo-700 rounded-2xl shadow-lg shadow-blue-500/30 dark:shadow-blue-900/50">
        <mat-icon class="text-white !text-5xl !w-12 !h-12" [svgIcon]="'tabler_outline:refresh'"></mat-icon>
      </div>
    </div>

    <!-- Nagłówek -->
    <h2 class="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-3 tracking-tight">
      Dostępna aktualizacja
    </h2>

    <!-- Opis -->
    <p class="text-base text-gray-600 dark:text-gray-400 mb-2 max-w-xs">
      Twoja wersja aplikacji jest nieaktualna i wymaga odświeżenia.
    </p>

    <!-- Wersje -->
    <div class="flex items-center justify-center gap-3 text-sm text-gray-500 dark:text-gray-500 mb-6">
      <span>Twoja wersja: <strong>{{ currentVersion }}</strong></span>
      <span>•</span>
      <span>Wymagana: <strong>{{ requiredVersion }}</strong></span>
    </div>

    <!-- Instrukcja - tylko dla Windows/Mac -->
    <div *ngIf="platform !== 'other'" class="w-full p-4 bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl border border-gray-200 dark:border-gray-700 mb-6">
      <p class="text-sm text-gray-700 dark:text-gray-300 mb-3 font-medium">Naciśnij i przytrzymaj jednocześnie:</p>
      <div class="flex items-center justify-center gap-3 text-sm">
        <ng-container *ngIf="platform === 'windows'">
          <span class="px-5 py-2.5 rounded-lg text-sm font-mono font-bold border-2 transition-all duration-150"
                [ngClass]="modifierPressed ? 'bg-blue-500 text-white border-blue-500 shadow-md' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 border-gray-300 dark:border-gray-600'">
            CTRL
          </span>
          <span class="text-gray-400 text-lg font-bold">+</span>
          <span class="px-5 py-2.5 rounded-lg text-sm font-mono font-bold border-2 transition-all duration-150"
                [ngClass]="rPressed ? 'bg-blue-500 text-white border-blue-500 shadow-md' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 border-gray-300 dark:border-gray-600'">
            R
          </span>
        </ng-container>
        <ng-container *ngIf="platform === 'mac'">
          <span class="px-5 py-2.5 rounded-lg text-sm font-mono font-bold border-2 transition-all duration-150"
                [ngClass]="modifierPressed ? 'bg-blue-500 text-white border-blue-500 shadow-md' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 border-gray-300 dark:border-gray-600'">
            ⌘ CMD
          </span>
          <span class="text-gray-400 text-lg font-bold">+</span>
          <span class="px-5 py-2.5 rounded-lg text-sm font-mono font-bold border-2 transition-all duration-150"
                [ngClass]="rPressed ? 'bg-blue-500 text-white border-blue-500 shadow-md' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 border-gray-300 dark:border-gray-600'">
            R
          </span>
        </ng-container>
      </div>
    </div>

    <!-- Przycisk -->
    <div class="w-full">
      <button 
        (click)="reloadApp()"
        class="group relative w-full h-12 inline-flex items-center justify-center text-base font-semibold text-white transition-all duration-300 rounded-xl overflow-hidden
               bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-600
               hover:from-blue-400 hover:via-blue-500 hover:to-indigo-500
               shadow-lg shadow-blue-500/25 hover:shadow-xl hover:shadow-blue-500/40
               hover:scale-[1.02] active:scale-100">
        <span class="relative z-10 flex items-center">
          <mat-icon [svgIcon]="'tabler_outline:refresh'" class="text-white"></mat-icon>
          <span class="ml-2">Zaktualizuj</span>
        </span>
        <div class="absolute inset-0 bg-gradient-to-r from-white/0 via-white/20 to-white/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
      </button>
    </div>
  </div>
</div>
